<template>
	<div>
		<div class="col-md-12 pr-0 pl-0 centre_sm_none">
			<div class="accountManage" v-show="detailShow">
				<p class="account_manage_title">Collection management</p>
				<ul class="clearfix tabc" role="">
                    <li class="item" @click="tab(item.id)" :class="{'cur':curIndex==item.id}" v-for='item in tabList'>{{item.name}}</li>
				</ul>
                <div class="tab-content">
                    <div class="nano video_breviary" id="accountSettings">
                        <div class="nano-content" id="home_right_list">
                            <ul  class="buteList clearfix">
                                <li class=" listItem clearfix" v-for="item in content">
                                    <img :src="item.thumb" alt="" v-if="item.thumb" />
                                    <div class="Rcontent">
                                        <a tag="p" class="title two_ell" @click="gotoDetail(item.contentid)">{{item.title}}</a>
                                        <p class="description two_ell">{{item.description}}</p>
                                        <div class="conBottom" :class="{'cur':item.thumb}">
                                            <img :src="item.author_avatar" alt="" v-if="curIndex==3" />
                                            <span class="conName" v-if="curIndex==3">{{item.author}}</span>
                                            <span class="conBlock" v-if="curIndex!=3">{{item.category}}</span>
                                            <span class="time"><span class="shu">|</span>{{item.published}}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        <div v-if="content.length ==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="" />
                            <p class="text-center p-2">loading</p>
                        </div>
                        </div>
                    </div>
			</div>
            </div>
            <div class="accountManage" v-show="!detailShow">
                <div style="border-bottom:rgba(0,0,0,.1);line-height: 60px;height:60px;position:relative;text-align:right;background:white">
                    <span class="myBtn" @click='goback()'>Back</span>
                </div>
                <div class="centre_content nano" id="centre_contents">
                <span class="nano-content p-4" >
                            <h1 class="information_article_headline">{{product.title}}</h1>
                            <p class="information_article_info">
                            <span class="mr-2">{{product.published}}</span>
                            <span v-if="product.author && product.author.length > 0">Author：<span class="mr-2" v-for="(value,index) in product.author">{{value}}</span>
                                                        </span>
                            <span v-if="product.source">Sources：{{product.source}}</span>
                            </p>
                            <div class="information_article_abstract rounded">
                            <p>
                                Abstract：{{product.description}}
                            </p>
                            </div>
                    <!-- 文章 -->
                    <div class="information_article_details text-indent2" v-if="product.appid == 1" v-html="product.content"></div>
                    <!-- 组图 -->
                    <div class="information_article_details text-indent2" v-if="product.appid == 2">
                            <div v-for="item in JSON.parse(product.content)">
                                <p>
                                    <img class="img-thumbnail" :src="item.url"/>
                                </p>
                                <p v-html="item.description"></p>
                            </div>
                            </div>
                    <!-- 视频 -->
                    <div class="information_article_details text-indent2" v-if="product.appid == 4">
                            <video id="my-video" class="video-js" controls preload="auto" style="width: 100%;" height="400" :poster="product.content" data-setup="{}">
                            <source ref="video" type="video/mp4">
                                <!--<p class="vjs-no-js"> To view this video please enable JavaScript, and consider upgrading to a web browser that
                                <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
                                </p>-->
                            </video>
                            </div>
                            <span class="f12 d-block mb-2" v-if="product.editor">Editor：{{product.editor}}</span>
                            </span>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
    import articles from './ArticleDetails/Article.vue'
	export default({
		name: 'collection',
        components: {
            articles
        },
		data: function() {
			return {
                detailShow:true,
                curIndex:1,
                total_page: 1,
                current_page : 1,
                page_size : 10,
                product : {}, // 文章详情
                tabList:[{
                    'id' : 1,
                    'name':"Article",
                },{
                    'id' : 2,
                    'name':"Photos",
                },{
                    'id' : 4,
                    'name':"Video",
                },{
                    'id' : 3,
                    'name':"Consultation",
                }],
                content:[]

			}
		},
		created: function() {
			this.getList();
		},
		methods: {
            getList() {
		        var that = this;
		        var param = {
                    'appid' : that.curIndex,
                    'current_page' : that.current_page,
                    'page_size' : that.page_size
                };
                this.$axios.post('/api/pc/getmycollect',param).then(data => {
                    if (data.data.state) {
                        that.content=data.data.data.data;
                        that.total_page=Math.ceil(data.data.data.total/that.page_size);
                    }
                })
            },
            gotoDetail(id){
                var that = this;
                this.$axios.post('/api/pc/getarticledetail', {
                    id: id
                }).then(response => {
                    if(response.data.state) {
                        this.detailShow=false;
                        that.product = response.data.data;
                    } else {
                        $(".wrap").text(response.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }

                })
            },
            goback(){
              this.detailShow=true;
            },
            tab(num){
                this.curIndex=num;
                this.current_page = 1;
                this.getList();
            },
            handleScroll() {
                let that = this;
                var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_right_list').scrollHeight; // 总高度
                if((all - 20) < (top + client)) {
                    this.current_page++;
                    if(this.current_page > this.total_page) {
                        return;
                    }
                    var param = {
                        'appid' : that.curIndex,
                        'current_page' : that.current_page,
                        'page_size' : that.page_size
                    };
                    this.$axios.post('/api/pc/getmycollect',param).then(data => {
                        if (data.data.state) {
                            var homeListes = data.data.data.data;
                            JSON.stringify(homeListes);
                            that.content= that.content.concat(homeListes);
                        }
                    })
                }

            },
		},
		mounted() {
            document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			this.load();
		}

	})
</script>
<style scoped type="text/css">
    .tabc{
        height:50px;
        padding-left:30px;
        margin:0;
        border-bottom:1px solid #EBEBEB;
    }
    .item{
        float: left;
        font-size:15px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(133,144,166,1);
        margin-right:50px;
        line-height:50px;
    }
    .item:hover{
        cursor:pointer;
    }
    .item.cur{
        color:#208EFF;
    }
    .shu{
        color:#D9D9D9;
        margin:0 15px;
    }
    .listItem{
        display: flex;
        align-items: flex-start;
        flex-direction: row;
        padding:30px 0;
        position:relative;
        border-bottom:1px solid #EBEBEB;
    }
    .column_active{
        background: none;
        color:#0066CE!important;
        border:none;
    }
    .buteList{
        padding:0 30px;
    }
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:15px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        z-index:100;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
    .two_ell {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .listItem img{
        max-width: 180px;
        height: auto;
        vertical-align: middle;
        margin-right:25px;
    }
    .Rcontent{
      /*position:relative;*/
    }
    .title{
        font-size:18px;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(38,38,38,1);
        line-height:26px;
    }
    .title:hover{
        cursor:pointer;
    }
    .description{
        height:40px;
        font-size:13px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:20px;
        margin:10px auto 15px!important;
    }
    .conBottom img{
        width:30px;
        height:30px;
        border-radius:50%;
        margin-right: 0px;
        border:1px solid white;
    }
    .conBottom.cur{
        /*position:absolute;*/
        bottom:15px
    }
    .conBlock{
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(69,133,245,1);
        line-height:17px;
        padding:3px 7px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(69,133,245,1);
    }
   .conName, .time{
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(89,89,89,1);
        line-height:17px;
    }
    @media screen and (max-width: 450px) {
        .listItem img{
            max-width: 130px;
        }
        .conBottom.cur{
            position:static
        }
    }

</style>
